<script>
    import {
        NormalCell,
        NormalButton
    } from 'southcn-mobile-ui';
    import NormalFeedback from './NormalFeedback';

    export default {
        name: 'NormalArticle',
        props: {
            data: {
                default () {
                    return {};
                },
                required: false
            },
            feedback: {
                required: false,
                default: '',
                type: String
            },
            feedbackAt: {
                required: false,
            }
        },
        data () {
            return {
                fileList: [],
                iframe: window._CONFIG.iframe
            };
        },
        components: {
            NormalCell,
            NormalButton,
            NormalFeedback
        },
        methods: {
            fetchFileDetail () {
                if (!this.data.attachments || !this.data.attachments.length) {
                    return;
                }
                const allPromise = this.data.attachments.filter(val => val && val != 0).map(v => {
                    return this.$api(this.$util.url(this.$config.apiUrl.attachments, v), {}, {method: 'GET'});
                });
                Promise.all(allPromise).then(v => {
                    this.fileList = v;
                }).catch(() => {
                    this.$modal.alert({
                        text: '获取附件失败'
                    });
                }).finally(() => {
                    this.$util.setIframeHeight();
                });
            },
            downloadFile (file) {
                window.open('/hdjlpt/yjzj/api/attachments/view/' + file.id);
            }
        },
        mounted () {
            this.fetchFileDetail();
            this.$util.setIframeHeight();
        }
    };
</script>
<template>
    <div class="article">
        <div class="article__props" v-if="!iframe">
            <div class="article__props-detail" v-show="data.author">
                <span class="key">作者：</span>
                <span class="value">{{data.author}}</span>
            </div>
            <div class="article__props-detail" v-show="data.editor">
                <span class="key">编辑：</span>
                <span class="value">{{data.editor}}</span>
            </div>
            <div class="article__props-detail" v-show="data.source">
                <span class="key">发布机构：</span>
                <span class="value">{{data.source}}</span>
            </div>
            <div class="article__props-detail" v-show="data.published_at">
                <span class="key">发布时间：</span>
                <span class="value">{{data.published_at}}</span>
            </div>
        </div>
        <div class="article__abstract" v-show="data.summary">
            {{data.summary}}
        </div>
        <div class="article__content" v-html="data.content">

        </div>

        <normal-feedback :feedback="feedback"
                         :feedbackAt="feedbackAt"/>

        <div class="article__attachment" v-if="fileList && fileList.length">
            <div class="article__attachment-title">
                相关附件
            </div>
            <div class="article__attachment-list" :key="item.id" v-for="item in fileList">
                <normal-cell>
                    <template v-slot:header>
                        &#xe646;
                    </template>
                    <template v-slot:default>
                        {{item.name}}
                    </template>
                    <template v-slot:footer>
                        <normal-button :download="true" @click.native="downloadFile(item)">下载</normal-button>
                    </template>
                </normal-cell>
            </div>
        </div>

    </div>
</template>
<style lang="less">
    @import "../../../southcn-mobile-ui/src/assets/less/widgets-var";

    .article {
        &__attachment {
            &-list {
                .normal-cell {
                    font-family: cmsicon;
                    color: @otherNormalTitleClr;

                    &__bd {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    &__ft {
                        margin-left: 8px;
                    }
                }
            }
        }
    }
</style>
<style scoped lang="less">
    @import "../../../southcn-mobile-ui/src/assets/less/widgets-var";

    .article {
        box-sizing: border-box;

        * {
            box-sizing: border-box;
        }

        &__feedback, &__attachment {
            .px2rem(font-size, 28);
            .px2rem(margin-bottom, 90);
            .px2rem(margin-top, 90);
            &-title {
                font-weight: bold;
                color: @otherNormalTitleClr;
                .px2rem(margin-bottom, 22);
                .px2rem(padding-bottom, 34);
                border-bottom: 1px solid @otherGreyBgClr;
            }

            &-time{
                font-weight: normal;
                color: @otherBtnBorderNoteClr;
                .px2rem(margin-left, 30);
            }

            &-content {
                color: #000;

            }

            &-list {
                .normal-cell {
                    padding-left: 0;
                    padding-right: 0;
                }
            }
        }

        &__content {
            .px2rem(font-size, 28);
            .px2rem(margin-top, 34);
        }

        &__props {
            &-detail {
                display: flex;
                justify-content: flex-start;
                color: @otherBtnBorderNoteClr;
                .px2rem(font-size, 26);
                .px2rem(margin-bottom, 20);
            }
        }

        &__abstract {
            .px2rem(margin-top, 34);
            .px2rem(padding-top, 32);
            .px2rem(padding-bottom, 32);
            .px2rem(padding-left, 17);
            .px2rem(padding-right, 17);
            .px2rem(font-size, 28);
            color: @otherTextClr;
            background-color: @otherBtnHoverClr;
            word-break: break-all;
        }
    }
</style>
